import * as React from 'react';

export default class BaseForm<P, S> extends React.PureComponent<P, S> {
  onValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    this.setState({ [e.target.name]: e.target.value } as any) // tslint:disable-line:no-any

  onBooleanChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    this.setState({ [e.target.name]: e.target.value === 'yes' } as any) // tslint:disable-line:no-any
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/baseForm.tsx